import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/uber': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M414.1 32c18.7 0 33.9 15.2 33.8 33.9v380.2c0 18.7-15.2 33.9-33.9 33.9h-380.1c-18.7 0-33.9-15.2-33.9-34v-380.1c0-18.7 15.2-33.9 33.9-33.9h380.2zM237.6 391.1c74.6-7.5 129-74.1 121.5-148.6-7-69.4-65.4-122.2-135.1-122.2s-128.1 52.8-135.1 122.2h94.4v-20.4c0-3.8 3.1-6.8 6.8-6.8h67.9c3.8 0 6.8 3.1 6.8 6.8v67.9c0 3.8-3.1 6.8-6.8 6.8h-67.9c-3.8 0-6.8-3.1-6.8-6.8v-20.4h-94.4c7.5 74.6 74.1 129 148.7 121.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/uber.js
// module id = 1063
// module chunks = 0